interface Props {
  title: string | JSX.Element
  subtitle?: string | JSX.Element
  className?: string
  theme?: keyof typeof themes
  subtitleClassName?: string
  titleClassName?: string
  textPosition?: keyof typeof textPositions
}

const themes = {
  title: {
    title: 'heading-1 mb-sm box-border',
    subTitle: 'large-normal box-border',
  },
  'title-2': {
    title: 'heading-2 mb-sm box-border',
    subTitle: 'large-normal box-border',
  },
  section: {
    title: 'large-strong box-border',
    subTitle: 'base-normal  box-border',
  },
  header: {
    title: 'large-strong box-border',
    subTitle: 'large-normal box-border',
  },
}

const textPositions = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
}

const SectionTitle = ({
  title,
  subtitle,
  theme = 'title',
  className,
  subtitleClassName,
  titleClassName,
  textPosition = 'center',
}: Props) => {
  return (
    <div className={`${textPositions[textPosition]} ${className} box-border`}>
      <div className={`text-black ${themes[theme]?.title} ${titleClassName}`}>
        {title}
      </div>
      {subtitle && (
        <div
          className={`text-dark-gray mb-lg ${themes[theme]?.subTitle} ${subtitleClassName}`}
        >
          {subtitle}
        </div>
      )}
    </div>
  )
}

export default SectionTitle
